import _default from './stripIndents';
export { _default as default };
